import type { ErrorsType } from '@/api/types/errors'
import { stringifyParams } from '@/lib/helpers'

import { sliceApi } from './api'

import type { QueryReturnValue } from '@reduxjs/toolkit/dist/query/baseQueryTypes'

export type GETMapStaticParams = {
  height: number
  lat: number
  lng: number
  width: number
}

export const mapSliceApi = sliceApi.injectEndpoints({
  endpoints: (builder) => ({
    getMapImage: builder.query<Blob, GETMapStaticParams>({
      queryFn: (params, _queryApi, _extraOptions, baseQuery) =>
        baseQuery({
          url: `/public/map/static${stringifyParams(params)}`,
          params,
          responseHandler: (response) => response.blob(),
        }) as Promise<QueryReturnValue<Blob, ErrorsType>>,
    }),
  }),
  overrideExisting: false,
})

export const { useGetMapImageQuery, useLazyGetMapImageQuery } = mapSliceApi
